module.exports = __webpack_public_path__ + "static/media/servicenow.647b5107.jpeg";